import FooterLogos from "./FooterLogos";
import FooterLinks from "./FooterLinks";
import FooterSocial from "./FooterSocial";
import FooterCopyright from "./FooterCopyright";

const Footer = () => {
  return (
    <footer className="relative h-[330px] bg-darkGreen text-light">
      <div className="absolute top-8 bottom-8 left-0 right-0 bg-primary flex flex-col items-center justify-center gap-4">
        <FooterLogos />

        {/* Desktop Layout */}
        <div className="hidden sm:flex flex-col items-center gap-4">
          <FooterLinks />
          <FooterSocial />
          <FooterCopyright />
        </div>

        {/* Mobile Layout */}
        <div className="flex flex-col items-center gap-3 sm:hidden text-center">
          <FooterSocial isMobile={true} />

          {/* Links stacked */}
          <div className="grid grid-cols-1 gap-2 mt-2">
            <FooterLinks />
          </div>

          <FooterCopyright isMobile={true} />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
